import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";

export const fetchCategoryBrands = createAsyncThunk(
  "category/fetchCategoryBrands",
  async (category, { rejectWithValue }) => {
    try {
      const response = await api.getCategoryBrands(category);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to load brands");
    }
  }
);

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    clearCategoryData: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryBrands.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryBrands.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCategoryBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCategoryData } = categorySlice.actions;
export default categorySlice.reducer;